import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  ActionButton,
  ActionButtonContainer,
} from "components/AgGrid/ActionButton";
import { ContextMenuPopoverButton } from "components/Button/MultiButton";

import { useIsMobile } from "hooks";

export function AgGridActionButtons({ actions }) {
  const isMobile = useIsMobile();
  if (!actions || !actions.length) {
    return null;
  }

  const shownActions = actions.filter(action => !action.hide);

  if (isMobile) {
    return (
      <ActionButtonContainer>
        <ContextMenuPopoverButton buttons={shownActions} />
      </ActionButtonContainer>
    );
  } else {
    return (
      <ActionButtonContainer>
        {shownActions.map(action => (
          <ActionButton
            data-tour={action.dataTour}
            type="button"
            onClick={action.onClick}
            disabled={action.isDisabled}
            key={action.title}
          >
            <FontAwesomeIcon icon={action.icon} />
            {action.title}
          </ActionButton>
        ))}
      </ActionButtonContainer>
    );
  }
}
